import { useEffect, useState } from "react";
import { api, backend, usePlayer } from "../app/services";
import { useStore } from "../lib/store";
import { useLoad } from "../lib/useLoad";
import { LibraryPage } from "./LibraryPage";
import { NowPlaying } from "./NowPlaying";
import { PlayerBar } from "./PlayerBar";
import { StationPage } from "./StationPage";

type Page = "station" | "library";

/** The signed-in window, laid out like the Mac app: pages on the left, what is playing
 * and the queue on the right, the transport along the bottom. */
export function Shell() {
  const { station, music } = usePlayer();
  const [page, setPage] = useState<Page>("station");
  const stationState = useStore(station);
  const billing = useLoad(() => backend.billing());
  const me = useLoad(() => backend.me());

  useEffect(() => {
    void station.findResumable();
  }, [station]);

  // Credits move with every batch the host voices.
  const reloadBilling = billing.reload;
  useEffect(() => {
    if (stationState.phase === "onAir" || stationState.phase === "failed") reloadBilling();
  }, [stationState.phase, reloadBilling]);

  async function signOut() {
    await station.stop();
    await music.signOut().catch(() => undefined);
    await api.signOut();
  }

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <img src="/icon.png" alt="" />
          <span>Radiola</span>
        </div>
        <nav className="tabs">
          <button
            type="button"
            className={page === "station" ? "active" : ""}
            onClick={() => setPage("station")}
          >
            My Station
          </button>
          <button
            type="button"
            className={page === "library" ? "active" : ""}
            onClick={() => setPage("library")}
          >
            Library
          </button>
        </nav>
        <div className="account">
          {billing.data && (
            <span className="pill" title="Credits pay for the AI host">
              {billing.data.available_credits.toLocaleString()} credits
            </span>
          )}
          <span className="muted">{me.data?.display_name ?? me.data?.nickname ?? ""}</span>
          <button type="button" className="quiet" onClick={() => void signOut()}>
            Sign Out
          </button>
        </div>
      </header>
      <main className="page">{page === "station" ? <StationPage /> : <LibraryPage />}</main>
      <aside className="inspector">
        <NowPlaying />
      </aside>
      <PlayerBar />
    </div>
  );
}
